import React from 'react';
import { Modal, Box, Typography, Card, CardMedia, CardContent, Grid, Chip } from '@mui/material';
import { Place, Event, Group, MonetizationOn } from '@mui/icons-material';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 500 },
    bgcolor: '#2D2D2D',
    color: 'white',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3,
    borderRadius: '8px',
};

const SessionDetailModal = ({ session, onClose }) => {
    if (!session) return null;

    const fillRate = session.capacity > 0 ? ((session.reservations / session.capacity) * 100).toFixed(0) : 0;

    return (
        <Modal open={!!session} onClose={onClose}>
            <Box sx={modalStyle}>
                <Typography variant="h5" component="h2" sx={{ mb: 1 }}>
                    {session.name}
                    <Chip label={session.sport} color="primary" sx={{ ml: 2 }} />
                </Typography>

                <Card sx={{ backgroundColor: '#424242', color: 'white' }}>
                    <CardMedia
                        component="img"
                        height="140"
                        image={session.venueImage1}
                        alt="Venue image"
                    />
                    <CardContent>
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12} container alignItems="center">
                                <Event sx={{ mr: 1.5 }} />
                                <Typography>{new Date(session.eventDate).toLocaleDateString()} | {session.eventTimeRange}</Typography>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Place sx={{ mr: 1.5 }} />
                                <Typography>{session.address}</Typography>
                            </Grid>
                            <Grid item xs={6} container alignItems="center">
                                <Group sx={{ mr: 1.5 }} />
                                <Typography>Fill Rate: {session.reservations}/{session.capacity} ({fillRate}%)</Typography>
                            </Grid>
                            <Grid item xs={6} container alignItems="center">
                                <MonetizationOn sx={{ mr: 1.5 }} />
                                <Typography>Revenue: ${session.sessionRevenue.totalRevenue}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1"><strong>Coach:</strong> {session.coachNames.join(', ')}</Typography>
                                <Typography variant="body1"><strong>Site Manager:</strong> {session.siteManagerNames.join(', ')}</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Modal>
    );
};

export default SessionDetailModal;